var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-popover",
    { attrs: { "auto-hide": true } },
    [
      _vm.type === "price"
        ? [
            _c(
              "button",
              {
                staticClass: "btn btn-xs btn-default",
                on: {
                  click: function ($event) {
                    return _vm.getData()
                  },
                },
              },
              [_c("i", { staticClass: "icon-fa icon-fa-balance-scale" })]
            ),
          ]
        : [
            _c(
              "button",
              {
                class: {
                  "btn btn-xs border-r-0": true,
                  "btn-danger": _vm.trend > 0,
                  "btn-success": _vm.trend < 0,
                  "btn-default": _vm.trend === 0,
                },
                on: {
                  click: function ($event) {
                    return _vm.getData()
                  },
                },
              },
              [
                _vm.trend < 0
                  ? _c("i", {
                      staticClass: "icon-fa icon-fa-angle-double-down",
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.trend > 0
                  ? _c("i", { staticClass: "icon-fa icon-fa-angle-double-up" })
                  : _vm._e(),
                _vm._v(" "),
                _vm.trend === 0
                  ? _c("i", { staticClass: "icon-fa icon-fa-exchange" })
                  : _vm._e(),
              ]
            ),
          ],
      _vm._v(" "),
      _c(
        "template",
        { slot: "popover" },
        [
          !_vm.loading
            ? [
                (_vm.loadedData ?? []).length
                  ? _c("div", [
                      _c(
                        "table",
                        {
                          staticClass:
                            "table popover_table_store_trends table-sm table-hover",
                        },
                        [
                          _c(
                            "tbody",
                            _vm._l(_vm.loadedData, function (r) {
                              return _c("tr", [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(_vm.printDate(r.date, "DD.MM.YYYY"))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.type === "price"
                                          ? r.price
                                          : r.stores
                                      )
                                    ),
                                  ]),
                                ]),
                              ])
                            }),
                            0
                          ),
                        ]
                      ),
                    ])
                  : _c("div", [_vm._v("\n        Нет данных\n      ")]),
              ]
            : [_vm._v("\n      Загрузка ....\n    ")],
          _vm._v(" "),
          _c("div", { staticClass: "mt-1 text-right" }, [
            _c(
              "button",
              {
                directives: [
                  { name: "close-popover", rawName: "v-close-popover" },
                ],
                staticClass: "btn btn-theme btn-sm",
              },
              [_vm._v("\n        Закрыть\n      ")]
            ),
          ]),
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }